module.exports = new __parcel__URL__("farm.cd24cb13.jpg").toString();